export const Calendar = () => {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 3H11V5H25V3H27V5H28C29.6569 5 31 6.34315 31 8V28C31 29.6569 29.6569 31 28 31H5V8C5 6.34315 6.34315 5 8 5H9V3ZM25 7V9H27V7H28C28.5523 7 29 7.44772 29 8V11H7V8C7 7.44772 7.44772 7 8 7H9V9H11V7H25ZM7 13V29H28C28.5523 29 29 28.5523 29 28V13H7Z"
                fill="white"
            />
            <rect x="10" y="16" width="5" height="5" fill="#FF6A39" />
        </svg>
    );
};
